<template>
    <a-table :columns="columns" :dataSource="dataSource" rowKey="id" :key="0" :loading="isReload"
    :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true  }" :locale="locale">
        <span slot="ban" slot-scope="text, row">
            <a-tag :color="(!row.ban)?'green':'red'">
                {{(!row.ban)?'ใช้งานได้':'บล็อค'}}
            </a-tag>
        </span>
        <span slot="superPartner" slot-scope="text, row">
            <a-tag :color="(!row.superPartner)?'red':'green'">
                {{(!row.superPartner)?'ปิด':'เปิด'}}
            </a-tag>
        </span>
        <a-dropdown slot="Action" slot-scope="text, row">
            <a-menu slot="overlay" >
                <a-menu-item key="0" @click="getDetailEmpPartnerSBO(row.id)"> <a-icon type="edit" />แก้ไขข้อมูลพนักงาน</a-menu-item>
                <a-menu-item key="1"> <router-link :to="`/sbo/empPartnerSBO/${row.id}`"> <a-icon type="menu" /> จัดการเมนูพนักงาน</router-link></a-menu-item>
                <a-menu-item key="2" @click="block(row)"> <a-icon type="close" /> {{(row.ban)?'เลิกบล็อค':'บล็อค'}}</a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px">จัดการ <a-icon type="down" /> </a-button>
        </a-dropdown>
    </a-table>
  </template>

<script>

import thTH from 'ant-design-vue/es/locale/th_TH'
import 'moment/locale/th'
import moment from 'moment'

moment.locale('th')
export default {
  props: [
    'id',
    'isReload',
    'dataSource',
  ],
  name: 'TableEmpPartnerSBO',
  data() {
    return {
      locale: thTH,
      thTH,
      columns: [
        {
          title: '',
          key: '',
          customRender: (text, row, index) => {
            return (index + 1)
          },
        },
        {
          title: 'พาร์ทเนอร์',
          key: 'name',
          dataIndex: 'name',
        },
        {
          title: 'ยูสเซอร์เนม',
          key: 'username',
          dataIndex: 'username',
        },
        {
          title: 'สถานะ',
          key: 'ban',
          dataIndex: 'ban',
          scopedSlots: { customRender: 'ban' },
        },
        {
          title: 'ซุปเปอร์',
          key: 'superPartner',
          dataIndex: 'superPartner',
          scopedSlots: { customRender: 'superPartner' },
        },
        {
          title: 'สร้างเมื่อ',
          key: 'createdAt',
          dataIndex: 'createdAt',
          customRender: (text, row, index) => {
            return moment(text).format('DD/MM/YYYY HH:mm:ss')
          },
        },
        {
          title: 'จัดการ',
          key: 'Action',
          dataIndex: 'id',
          scopedSlots: { customRender: 'Action' },
        },
      ],
    }
  },
  // watch: {
  //   isReload() {
  //     if (this.isReload) {
  //       this.reload()
  //     }
  //   },
  // },
  methods: {

    getDetailEmpPartnerSBO(id) {
      this.$emit('edit-submitted', id)
    },
    getDetailMenuEmpPartnerSBO(id) {
      this.$emit('edit-menu-submitted', id)
    },
    block(result) {
      this.$emit('block-submitted', result)
    },
  },
}
</script>

  <style>

  </style>
